<template>
  <NuxtLayout name="markup" background-class="bg-surface-tertiary">
    <MarkupGenerator :page-data="markupData" :is-page="true" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { general_setPageTheme } from '~/utils/general/pageThemeClassFromMarkup';
import { ASYNC_KEY_STUDENT_LISTING } from '~/models/AsyncDataKeys.model';

const config = useRuntimeConfig();
const route = useRoute();
const { $api } = useNuxtApp();
const notifications = useNotificationStore();
notifications.reset();

definePageMeta({
  layout: false,
});

const { data: markupData, error } = await useAsyncData(
  ASYNC_KEY_STUDENT_LISTING,
  async () => {
    return await $api.categoryModule.getCategory(8);
  },
  {
    transform: cache_addFetchedAtTransform,
    getCachedData: cache_getCachedDataFromServer,
  },
);

if (error.value) {
  notifications.setStandardErrorNotification();
}

filters_initializeFiltersIfListComponentExists(markupData.value, false);
general_setPageTheme(markupData.value?.PageContent);

const canonicalUrl = `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;

const seoInput = {
  seoData: {
    title: markupData?.value?.MetaTitle,
    description: markupData?.value?.MetaDescription,
    siteName: 'Halebop',
    keywords: markupData?.value?.MetaKeywords,
    canonicalUrl,
  },
  fallBackSeoData: {
    title: 'Studentrabatt mobilabonnemang | Halebop.se',
    description:
      'Du som är student får bättre pris på abonnemanget Halebop Rubbet med vårt studenterbjudande. Välj med mobil och fastpris.',
    siteName: 'Halebop',
    keywords: '',
    canonicalUrl,
  },
};
useCustomSeoMeta(seoInput);
</script>
<style scoped lang="scss"></style>
